const moment = require("moment")

export const Calculator = {
  getDrawdowns(returns) {
    const drawdowns = [1]
    for (let i = 1; i <= returns.length; i++) {
        const rate = returns[i - 1]
        if (rate > 0) {
            if (drawdowns[i - 1] >= 1) {
                drawdowns.push(1)
            } else {
                drawdowns.push(drawdowns[i - 1] * (1 + rate))
            }
        } else {
            drawdowns.push(drawdowns[i - 1] * (1 + rate))
        }
    }
    return drawdowns.map(x => x >= 1 ? 0 : (x - 1) * 100)
  },
  buildYearReturns(monthAmounts) {
    const monthReturns = [1]
    const yearReturns = []

    for (let i = 1; i < monthAmounts.length; i++) {
        monthReturns.push(monthAmounts[i] / monthAmounts[i - 1])
    }

    let yearReturn = 100
    for (let i = 1; i < monthReturns.length; i++) {
        yearReturn *= monthReturns[i]
        
        if (i % 12 == 0 || i == monthReturns.length - 1) {
            yearReturns.push(yearReturn - 100)
            yearReturn = 100
        }
    }

    return yearReturns
  },
  buildAbstractResult(name, startCash, monthInterval, monthlyAmount, yearReturns, monthDrawdowns) {
    const cagr = 100 * (Math.pow(monthlyAmount[monthlyAmount.length - 1] / startCash, 1 / (monthInterval / 12)) - 1)
    const stdev = this.getStandardDeviation(yearReturns) * 100
    const minusStdev = this.getStandardDeviationForMinusYears(yearReturns) * 100

    return {
      name,
      initial: startCash.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
      final: monthlyAmount[monthlyAmount.length - 1].toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
      cagr: `${cagr.toFixed(2)} %`,
      stdev: `${stdev.toFixed(2)} %`,
      best: `${Math.max.apply(null, yearReturns).toFixed(2)} %`,
      worst: `${Math.min.apply(null, yearReturns).toFixed(2)} %`,
      mdd: `${Math.min.apply(null, monthDrawdowns.filter(x => !isNaN(x))).toFixed(2)} %`,
      sharpe: (cagr / stdev).toFixed(2),
      sortino: (cagr / minusStdev).toFixed(2)
    }
  },
  getStandardDeviation(yearReturnPercents) {
    const yearReturnValues = yearReturnPercents.map(x => x / 100)
    const n = yearReturnValues.length

    if (n == 0) return NaN

    const mean = yearReturnValues.reduce((a, b) => a + b) / n
    return Math.sqrt(yearReturnValues.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / (n - 1))
  },
  getStandardDeviationForMinusYears(yearReturnPercents) {
    const yearReturnValues = yearReturnPercents.filter(x => x < 0).map(x => x / 100)
    const n = yearReturnValues.length

    if (n == 0) return NaN

    const mean = yearReturnValues.reduce((a, b) => a + b) / n
    return Math.sqrt(yearReturnValues.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / (n - 1))
  },
  getMonthInterval(startSplits, endSplits) {
      const startYear = parseInt(startSplits[0])
      const startMonth = parseInt(startSplits[1])

      const endYear = parseInt(endSplits[0])
      const endMonth = parseInt(endSplits[1])

      const interval = moment(`${endYear}-${endMonth}-1`).diff(moment(`${startYear}-${startMonth}-1`), 'months', true)
      return Math.abs(interval)
  },
}